import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { AboutKarina } from './components/AboutKarina';
import { TransitionBlock } from './components/TransitionBlock';
import { Products } from './components/Products';
import { Description } from './components/Description';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { ShopifyDescription } from './components/ShopifyDescription';
import { BrandClosing } from './components/BrandClosing';
import { Footer } from './components/Footer';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/q7RnjxXyHz353QdkW84P8k/IMG_5459.jpg';
export function App() {
  useEffect(() => {
    document.title = 'Alexa Beauty Brows And Lashes';
    const setMeta = (name: string, content: string) => {
      let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    };
    setMeta('application-name', 'Alexa Beauty Brows And Lashes');
    setMeta('description', 'Alexa Beauty Brows And Lashes — kits premium para pestañas. Organización, elegancia y profesionalismo en un solo kit.');
    let icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!icon) {
      icon = document.createElement('link');
      icon.rel = 'icon';
      document.head.appendChild(icon);
    }
    icon.href = LOGO_URL;
  }, []);
  return <div className="min-h-screen bg-nude-light font-sans selection:bg-gold selection:text-luxury-black" data-id="element-0" data-mp="38l8idsyfc0if">
      {/* Floating Badge Example - can be positioned anywhere, placing it fixed for demo */}
      <div className="fixed bottom-6 right-6 z-50 animate-bounce" data-id="element-1" data-mp="nw2bc3tnpmq1">
        <div className="bg-white text-luxury-black font-bold text-xs tracking-wider uppercase px-4 py-2 rounded-full shadow-lg border border-gold/30 flex items-center gap-2" data-id="element-2" data-mp="nxwxflgnzkvp">
          ✨ NUEVO
        </div>
      </div>

      <main data-id="element-3" data-mp="3ud1hdeu8fyd9">
        <Hero data-id="element-4" data-mp="3udayecxauv6t" />
        <AboutKarina data-id="element-5" data-mp="3ubrg6gs32a2e" />
        <TransitionBlock data-id="element-6" data-mp="3uc9i9u1ffii8" />
        <Products data-id="element-7" data-mp="3uf5hdlp0gd89" />
        <Description data-id="element-8" data-mp="d4e4tqw8j8vn" />
        <Benefits data-id="element-9" data-mp="d4xmd6hz3v95" />
        <Testimonials data-id="element-10" data-mp="d45sc040y5kz" />
        <CTASection data-id="element-11" data-mp="d2l7x3bfc30u" />
        <ShopifyDescription data-id="element-12" data-mp="85l0anyxes7m" />
        <BrandClosing data-id="element-13" data-mp="85b8cuubmaza" />
      </main>

      <Footer data-id="element-14" data-mp="86ckz3qzj5j4" />
    </div>;
}